<div class="flex" style="height: 100vh; overflow: hidden;">
    <div class="login flex align-items-center justify-content-center">
        <div class="login-container flex flex-column gap-5">
            <img src="assets/icons/login-header.svg" width="156px" height="38px"/>
            <div class="login-description">
                <p>Que bom te ver <strong>por aqui de novo!</strong></p>
                <span>Informe seus dados para acessar sua conta</span>
            </div>
            <div class="login-container-form flex flex-column gap-3">
                <form [formGroup]="formAuth" class="flex flex-column gap-3">
                    <ng-container *ngIf="!instructionSent && !showPasswordForm">
                        <div class="flex flex-column gap-2">
                            <label for="email">Email</label>
                            <span class="p-input-icon-right">
                                <input formControlName="email" splitValidadorCampoFormulario class="w-full" pInputText type="email" id="email" > 
                            </span>
                        </div>
                        <p class="incorrect-label" *ngIf="error">Usuário não encontrado!</p>
                        <a [routerLink]="['/login']" class="link">Voltar para o login</a>
                        <button (click)="redefinirSenha()"  pRipple class="btn-login w-full h-3rem" pButton> 
                            <div class="text-center w-full">
                                Redefinir senha
                            </div> 
                        </button>
                    </ng-container>
                    <ng-container *ngIf="instructionSent && !showPasswordForm">
                        <div>
                            <svg width="64" height="64" viewBox="0 0 80 80" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10 23.3334C10 21.5653 10.7024 19.8696 11.9526 18.6194C13.2029 17.3691 14.8986 16.6667 16.6667 16.6667H63.3333C65.1014 16.6667 66.7971 17.3691 68.0474 18.6194C69.2976 19.8696 70 21.5653 70 23.3334V56.6667C70 58.4349 69.2976 60.1306 68.0474 61.3808C66.7971 62.631 65.1014 63.3334 63.3333 63.3334H16.6667C14.8986 63.3334 13.2029 62.631 11.9526 61.3808C10.7024 60.1306 10 58.4349 10 56.6667V23.3334Z"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M10 23.3335L40 43.3335L70 23.3335" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <h1 class="title">Recuperar senha</h1>
                        <p class="text-info-1 mb-3">
                            As instruções de recuperação foram enviadas <br />
                            para o seu e-mail
                        </p>
                        <a [routerLink]="['/login']" class="link">Voltar para o login</a>
                    </ng-container>

                    <ng-container *ngIf="showPasswordForm && !success">
                        <div class="flex flex-column gap-2">
                            <label for="password">Senha</label>
                            <span class="p-input-icon-right">
                                <input formControlName="password" splitValidadorCampoFormulario class="w-full" pInputText type="password" id="password" > 
                            </span>
                        </div>
                        <div class="flex flex-column gap-2">
                            <label for="password">Confirmar senha</label>
                            <span class="p-input-icon-right">
                                <input formControlName="confirmPassword" splitValidadorCampoFormulario class="w-full" pInputText type="password" id="password" > 
                            </span>
                        </div>
                        <p class="incorrect-label" *ngIf="error">Usuário não encontrado!</p>
                        <button (click)="sendNewPassword()"  pRipple class="btn-login w-full h-3rem" pButton> 
                            <div class="text-center w-full">
                                Redefinir senha
                            </div> 
                        </button>
                    </ng-container>
                    <ng-container *ngIf="showPasswordForm && success">
                        <div>
                            <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1 33C1 37.2023 1.8277 41.3635 3.43585 45.2459C5.04401 49.1283 7.40111 52.6559 10.3726 55.6274C13.3441 58.5989 16.8717 60.956 20.7541 62.5641C24.6365 64.1723 28.7977 65 33 65C37.2023 65 41.3635 64.1723 45.2459 62.5641C49.1283 60.956 52.6559 58.5989 55.6274 55.6274C58.5989 52.6559 60.956 49.1283 62.5641 45.2459C64.1723 41.3635 65 37.2023 65 33C65 28.7977 64.1723 24.6365 62.5641 20.7541C60.956 16.8717 58.5989 13.3441 55.6274 10.3726C52.6559 7.40111 49.1283 5.04401 45.2459 3.43586C41.3635 1.8277 37.2023 1 33 1C28.7977 1 24.6365 1.8277 20.7541 3.43586C16.8717 5.04401 13.3441 7.40111 10.3726 10.3726C7.40111 13.3441 5.04401 16.8717 3.43585 20.7541C1.8277 24.6365 1 28.7977 1 33Z"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22.332 32.9998L29.4431 40.1109L43.6654 25.8887" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                        </div>
                        <h1 class="title">Sucesso!</h1>
                        <p class="text-info-1 mb-3" >
                            Sua senha foi redefinida com sucesso
                        </p>
                        <a [routerLink]="['/login']" class="link">Voltar para o login</a>
                    </ng-container>
                </form>
                <div class="login-loading" *ngIf="loading">
                    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
                </div>
            </div>
        </div>
    </div>
    <div class="banner flex-1">
        <div class="banner-container flex flex-column gap-7">
            <p><strong>Gestão</strong> e <strong>automatização</strong> financeira integrado com a sua agenda</p>

            <div class="slide-container flex align-items-center relative">
                <div class="slide-content">
                    <div class="absolute">
                        <ul class="flex gap-7" [ngStyle]="{ 'transform': 'translateX(' + this.latX + 'px)' }">
                            <li *ngFor="let slide of slides; let i = index" [ngClass]="{ 'active': slide.active }" >
                                <img  #img [src]="slide.img">
                            </li>

                        </ul>
                    </div>
                    <p-button (click)="prevSlide()" class="btn-slide-prev" icon="pi pi-angle-left" [rounded]="true" severity="secondary" />
                    <p-button (click)="nextSlide()"  class="btn-slide-next" icon="pi pi-angle-right" [rounded]="true" severity="secondary" />
                </div>
            </div>
        </div>
    </div>
</div>



<!--<form [formGroup]="formAuth">
    <main class="flex justify-content-center absolute w-full h-full">
        <div class="login-container  flex flex-grow">
            <div class="flex-1 login-left-side">
                <div class="flex flex-1  justify-content-center align-items-center" style="flex-direction: column;">
                    <div class="flex justify-content-center p-5">
                        <img src="assets/icons/login-header.svg">
                    </div>
                    <div class="text-center">
                        <span class="lbl-gestao">
                            Conheça a Split Pay.<br />
                            O Software de Gestão<br />
                            <b>que resolve seus problemas</b>
                        </span>
                    </div>
                    <div class="flex justify-content-center w-full">
                        <img src="/assets/login/doctor.svg" style="max-width: 320px;">
                    </div>
                </div>
            </div>


            <div *ngIf="!instructionSent && !showPasswordForm" class="col-6 login-right-side relative p-0">
                <div class="flex absolute h-full w-full align-items-center" style="flex-direction:column">
                    <div class="flex flex-1 align-items-center justify-content-center w-full"
                        style="flex-direction:column">
                        <div class="card card-container flex" style="flex-direction:column">
                            <div class="flex flex-1  align-items-center" style="flex-direction:column">
                                <div class="w-full flex justify-content-center mt-5 mb-5">
                                    <img src="assets/login/logo.svg">
                                </div>
                                <div class="mb-4">
                                    <h1 class="title">Recuperar senha</h1>
                                    <p class="text-info-1">
                                        Insira seu e-mail para redefinir sua senha
                                    </p>
                                </div>
                                <div *ngIf="!loading" class="mb-5">
                                    <input formControlName="email" class="input-credentials w-25rem" pInputText
                                        placeholder="Email" splitValidadorCampoFormulario />
                                </div>
                                <div *ngIf="!loading">
                                    <button (click)="redefinirSenha()" pRipple class="btn-login w-25rem h-3rem" pButton>
                                        <div class="text-center w-full">
                                            REDEFINIR SENHA
                                        </div>
                                    </button>

                                    <p (click)="navigateLogin()" class="signup mt-5 cursor-pointer"><b><u
                                                style="color:var(--secondary-color)">Desejo voltar para o login</u></b>
                                    </p>

                                </div>
                                <div *ngIf="loading" class="flex align-items-center justify-content-center">
                                    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
                                </div>
                                <div>
                                    <p *ngIf="error && !loading" class="warn -mt-3">Usuário não encontrado!</p>
                                </div>
                                <div>
                                    <button pRipple class="social-btn-login w-25rem hidden">
                                        <div class="flex flex-grow ">
                                            <div class="icon-container">
                                                <img src="/assets/login/google.svg" class="pr-5 pl-5">
                                            </div>
                                            <div class="flex-1">
                                                <p class="title text-left p-0 m-0">Entre com sua conta do Google</p>
                                                <p class="subtitle text-left p-0 m-0">Acesse agora mesmo</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <p class="signup">Ainda não é cliente ? <b><u style="color:var(--secondary-color)">Fale com
                                        um especialista</u></b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="instructionSent && !showPasswordForm" class="col-6 login-right-side relative p-0">
                <div class="flex absolute h-full w-full align-items-center" style="flex-direction:column">
                    <div class="flex flex-1 align-items-center justify-content-center w-full"
                        style="flex-direction:column">
                        <div class="card card-container flex" style="flex-direction:column">
                            <div class="flex flex-1  align-items-center" style="flex-direction:column">
                                <div class="w-full flex justify-content-center mt-5 mb-5">
                                    <img src="assets/login/logo.svg">
                                </div>
                                <div class="mb-4 flex align-items-center justify-content-center flex-1"
                                    style="flex-direction:column">
                                    <div>
                                        <svg width="64" height="64" viewBox="0 0 80 80" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M10 23.3334C10 21.5653 10.7024 19.8696 11.9526 18.6194C13.2029 17.3691 14.8986 16.6667 16.6667 16.6667H63.3333C65.1014 16.6667 66.7971 17.3691 68.0474 18.6194C69.2976 19.8696 70 21.5653 70 23.3334V56.6667C70 58.4349 69.2976 60.1306 68.0474 61.3808C66.7971 62.631 65.1014 63.3334 63.3333 63.3334H16.6667C14.8986 63.3334 13.2029 62.631 11.9526 61.3808C10.7024 60.1306 10 58.4349 10 56.6667V23.3334Z"
                                                stroke="#086975" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M10 23.3335L40 43.3335L70 23.3335" stroke="#086975"
                                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <h1 class="title">Recuperar senha</h1>
                                    <p class="text-info-1 mb-3" style="color: gray">
                                        As instruções de recuperação foram enviadas <br />
                                        para o seu e-mail
                                    </p>
                                    <p class="p-0 m-0" (click)="navigateLogin()" class="signup cursor-pointer"><b><u
                                                style="color:var(--secondary-color)">Desejo voltar para o login</u></b>
                                    </p>
                                </div>
                                <div>
                                    <p class="forgot-password-text pb-4 hidden" pRipple>Esqueci minha senha</p>
                                </div>
                                <div>
                                    <button pRipple class="social-btn-login w-25rem hidden">
                                        <div class="flex flex-grow ">
                                            <div class="icon-container">
                                                <img src="/assets/login/google.svg" class="pr-5 pl-5">
                                            </div>
                                            <div class="flex-1">
                                                <p class="title text-left p-0 m-0">Entre com sua conta do Google</p>
                                                <p class="subtitle text-left p-0 m-0">Acesse agora mesmo</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <p class="signup">Ainda não é cliente ? <b><u style="color:var(--secondary-color)">Fale com
                                        um especialista</u></b></p>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="showPasswordForm && !success" class="col-6 login-right-side relative p-0">
                <div class="flex absolute h-full w-full align-items-center" style="flex-direction:column">
                    <div class="flex flex-1 align-items-center justify-content-center w-full"
                        style="flex-direction:column">
                        <div class="card card-container flex" style="flex-direction:column">
                            <div class="flex flex-1  align-items-center" style="flex-direction:column">
                                <div class="w-full flex justify-content-center mt-5 mb-5">
                                    <img src="assets/login/logo.svg">
                                </div>
                                <div class="mb-4">
                                    <h1 class="title">Recuperar senha</h1>

                                </div>
                                <div *ngIf="!loading" class="mb-3">
                                    <p-password formControlName="password" placeholder="Nova senha"
                                        splitValidadorCampoFormulario 
                                        [feedback]="false" [toggleMask]="true"></p-password>
                                </div>
                                <div *ngIf="!loading" class="mb-5">

                                    <p-password formControlName="confirmPassword" placeholder="Confirmar senha"
                                        splitValidadorCampoFormulario [feedback]="false"
                                        [toggleMask]="true"></p-password>
                                </div>
                                <div *ngIf="!loading">
                                    <button (click)="sendNewPassword()" pRipple class="btn-login w-25rem h-3rem"
                                        pButton>
                                        <div class="text-center w-full">
                                            REDEFINIR SENHA
                                        </div>
                                    </button>

                                    <p (click)="navigateLogin()" class="signup mt-5 cursor-pointer"><b><u
                                                style="color:var(--secondary-color)">Desejo voltar para o login</u></b>
                                    </p>

                                </div>
                                <div *ngIf="loading" class="flex align-items-center justify-content-center">
                                    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
                                </div>
                                <div>
                                    <p *ngIf="error && !loading" class="warn -mt-3">{{errorMessage}}</p>
                                    <p *ngIf="success && !loading" class="success -mt-3">Senha redefinida com sucesso</p>
                                </div>
                                <div>
                                    <button pRipple class="social-btn-login w-25rem hidden">
                                        <div class="flex flex-grow ">
                                            <div class="icon-container">
                                                <img src="/assets/login/google.svg" class="pr-5 pl-5">
                                            </div>
                                            <div class="flex-1">
                                                <p class="title text-left p-0 m-0">Entre com sua conta do Google</p>
                                                <p class="subtitle text-left p-0 m-0">Acesse agora mesmo</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <p class="signup">Ainda não é cliente ? <b><u style="color:var(--secondary-color)">Fale com
                                        um especialista</u></b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showPasswordForm && success" class="col-6 login-right-side relative p-0">
                <div class="flex absolute h-full w-full align-items-center" style="flex-direction:column">
                    <div class="flex flex-1 align-items-center justify-content-center w-full"
                        style="flex-direction:column">
                        <div class="card card-container flex" style="flex-direction:column">
                            <div class="flex flex-1  align-items-center" style="flex-direction:column">
                                <div class="w-full flex justify-content-center mt-5 mb-5">
                                    <img src="assets/login/logo.svg">
                                </div>
                                <div class="mb-4 flex align-items-center justify-content-center flex-1"
                                    style="flex-direction:column">
                                    <div>
                                        <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M1 33C1 37.2023 1.8277 41.3635 3.43585 45.2459C5.04401 49.1283 7.40111 52.6559 10.3726 55.6274C13.3441 58.5989 16.8717 60.956 20.7541 62.5641C24.6365 64.1723 28.7977 65 33 65C37.2023 65 41.3635 64.1723 45.2459 62.5641C49.1283 60.956 52.6559 58.5989 55.6274 55.6274C58.5989 52.6559 60.956 49.1283 62.5641 45.2459C64.1723 41.3635 65 37.2023 65 33C65 28.7977 64.1723 24.6365 62.5641 20.7541C60.956 16.8717 58.5989 13.3441 55.6274 10.3726C52.6559 7.40111 49.1283 5.04401 45.2459 3.43586C41.3635 1.8277 37.2023 1 33 1C28.7977 1 24.6365 1.8277 20.7541 3.43586C16.8717 5.04401 13.3441 7.40111 10.3726 10.3726C7.40111 13.3441 5.04401 16.8717 3.43585 20.7541C1.8277 24.6365 1 28.7977 1 33Z"
                                                stroke="#0A8300" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22.332 32.9998L29.4431 40.1109L43.6654 25.8887" stroke="#0A8300" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                    </div>
                                    <h1 class="title">Sucesso!</h1>
                                    <p class="text-info-1 mb-3" style="color: gray">
                                        Sua senha foi redefinida com sucesso
                                    </p>
                                    <p class="p-0 m-0" (click)="navigateLogin()" class="signup cursor-pointer"><b><u
                                                style="color:var(--secondary-color)">Desejo voltar para o login</u></b>
                                    </p>
                                </div>
                                <div>
                                    <p class="forgot-password-text pb-4 hidden" pRipple>Esqueci minha senha</p>
                                </div>
                                <div>
                                    <button pRipple class="social-btn-login w-25rem hidden">
                                        <div class="flex flex-grow ">
                                            <div class="icon-container">
                                                <img src="/assets/login/google.svg" class="pr-5 pl-5">
                                            </div>
                                            <div class="flex-1">
                                                <p class="title text-left p-0 m-0">Entre com sua conta do Google</p>
                                                <p class="subtitle text-left p-0 m-0">Acesse agora mesmo</p>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <p class="signup">Ainda não é cliente ? <b><u style="color:var(--secondary-color)">Fale com
                                        um especialista</u></b></p>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    </main>-->